import axios from 'axios'
import type { AuthTokens, LoginCredentials, User } from '@/types/auth'

export async function login(credentials: LoginCredentials): Promise<AuthTokens> {
  const { data } = await axios.post('/api/v1/auth/token/obtain', {
    data: { username: credentials.email, password: credentials.password },
  })
  return { access: data.result.access_token, refresh: data.result.refresh_token }
}

export async function refreshToken(refresh: string): Promise<{ access: string }> {
  const { data } = await axios.post('/api/v1/auth/token/refresh', {
    data: { refresh_token: refresh },
  })
  return { access: data.result.access_token }
}

export async function getMe(accessToken: string): Promise<User> {
  const { data } = await axios.post<{ result: User }>('/api/v1/auth/me', {}, {
    headers: { Authorization: `Bearer ${accessToken}` },
  })
  return data.result
}
